













import Vue from "vue";
import Component from "vue-class-component";
import ClipLoader from "vue-spinner/src/ClipLoader.vue";

const LoadingButtonProps = Vue.extend({
  props: {
    isLoading: Boolean,
    text: String,
    onClick: Function,
    minWidth: String,
    disabled: Boolean,
    color: String,
    size: String
  }
});

@Component({
  components: {
    ClipLoader
  }
})
export default class LoadingButton extends LoadingButtonProps {}
